import config from './config'

export default {
  name: 'wbap-admin-root',
  version: '1.0.0',
  description: '项目启动页,用于判断是否登录,如果登录则进入首页,如果未登录,则跳转登录页',
  config: config,
  components: [],
  load: (cb) => {
    cb(require('./page').default, require('./model').default)
  }
}


// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-root/index.js